// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "flyonui/flyonui"
import "./cookieconsent-config"

const el = document.getElementById('phone-number');
el.textContent = el.dataset.phone.replace(/(\+420)(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');

document.addEventListener("DOMContentLoaded", () => {
    const scrollTarget = document.querySelector("[data-scroll]");
    if (scrollTarget) {
        scrollTarget.scrollIntoView({ behavior: "smooth" });
    }
});
